import React from 'react';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import isDesktop from 'store/app/selector/isDesktop';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import OpPlusLogoSmall from 'components/Common/Icons/opplus/OpPlusLogoSmall';
import getOpPlusV3Info from 'store/dashboard/selector/getOpPlusV3Info';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import styles from './PlusBanner.module.scss';

const PlusBanner = () => {
  const isDesktopDevice = useSelector(isDesktop);
  const subscriptionData = useSelector(getOpPlusV3Info);
  const { t } = useTranslation();

  const onLearnMoreHandler = () => {
    gtmSendEvent({
      event: 'your_dashboard',
      click: 'plus section learn more',
    });
    window.location.href = '/plus-membership';
  };

  return (
    <div className={styles.plusBanner}>
      <div className={styles.welcomeMessage}>
        <OpText variant="title-small-bold">
          {t('txt_plus_welcome')}, {subscriptionData?.customerInfo.firstName}!
        </OpText>
        <OpPlusLogoSmall />
      </div>
      <OpText variant={isDesktopDevice ? 'title-medium-bold' : 'body-large-bold'}>{t('txt_plus_banner_title')}</OpText>
      <div className={styles.learnMore} onClick={onLearnMoreHandler}>
        <OpText variant="title-small-regular">{t('txt_plus_banner_learn_more')}</OpText>
        <OpIcon icon="arrow-right" />
      </div>
    </div>
  );
};

export default PlusBanner;
